import React, { useEffect } from "react";
import Datafeed from "../trading-view/datafeed";

const TradingViewChart = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/jsx";
    script.src = "%PUBLIC_URL%/charting_library/charting_library.standalone.js";
    document.head.appendChild(script);

    const url = new URL(window.location.href)
    var tmpdata = url.pathname.split("/")

    let overridesLight = {
      "paneProperties.background": "#FFF",
      "paneProperties.backgroundType": "solid"
    }
    let overridesDark = {
      "paneProperties.background": "#1E1F33",
      "paneProperties.backgroundType": "solid",

      "mainSeriesProperties.statusViewStyle.showInterval": false,
      "mainSeriesProperties.statusViewStyle.symbolTextSource": "long-description",
    }
    window.tvWidget = new window.TradingView.widget({
      debug: false,
      client_id: 'tradingview.com',
      user_id: 'public_user_id',
      symbol: (tmpdata.length >= 4 ? (tmpdata[3].toUpperCase() === '' ? 'ADAIDR' : tmpdata[3].toUpperCase()+tmpdata[4].toUpperCase()  ) : 'ADAIDR'),
      interval: '1D',
      theme: (tmpdata.length >= 4 ? (tmpdata[2].toUpperCase() === '' ? 'DARK' : tmpdata[2].toUpperCase()) : 'DARK'),
      overrides: (tmpdata.length >= 4 ? (tmpdata[2].toUpperCase() === 'DARK' ? overridesDark : overridesLight) : overridesDark),
      fullscreen: true,
      datafeed: Datafeed,
      library_path: "/charting_library/",
      allow_symbol_change: false,
      timezone: 'Asia/Jakarta',
      autosize: true,
      locale: (tmpdata.length >= 4 ? (tmpdata[1].toUpperCase() !== 'EN' ? 'id_ID' : tmpdata[1].toUpperCase()) : 'id_ID'),
      style: '1',
      custom_css_url: '/style.css',
      disabled_features: ["use_localstorage_for_settings", "control_bar", "header_undo_redo", "link_to_tradingview", "header_compare", "compare_symbol", "timezone_menu", "symbol_search_hot_key", "header_symbol_search", "", "timeframes_toolbar", "header_fullscreen_button"],
      enabled_features: ["hide_left_toolbar_by_default"],
      container: "tv_chart_container",
    });

    //"create_volume_indicator_by_default"

  //   window.tvWidget.onChartReady(() => {
  //     const priceScale = window.tvWidget.activeChart().getPanes()[0].getRightPriceScales()[0];
  //     priceScale.setMode(4);
  // });

    //SCRIPT VISIBLE RANGE
    // window.tvWidget.onChartReady(function () {
    //   var chart = window.tvWidget.chart();
    //   chart.setVisibleRange({
    //     from: Date.UTC(2023, 8, 1) / 1000,
    //     to: Date.UTC(2023, 8, 24) / 1000
    //   });
    // });

    //SCRIPT MEMBUAT STUDI DEFAULT
    // window.tvWidget.onChartReady(function () {
    // window.tvWidget.activeChart().createStudy('Moving Average', false, true);
    // window.tvWidget.activeChart().createStudy('Volume', false, true);
    // window.tvWidget.activeChart().createStudy('MACD', false, true, { in_0: 14, in_1: 30, in_3: 'close', in_2: 9 });
    // window.tvWidget.activeChart().createStudy('Relative Strength Index', false, true);
    // });

    //SCRIPT MEMBUAT BUTTON TOOLBAR CUSTOM
    // window.tvWidget.headerReady().then(function () {
    //   var button = window.tvWidget.createButton();
    //   button.setAttribute('title', 'Depth');
    //   button.addEventListener('click', function () { alert("Depth pressed!"); });
    //   // button.style({'float': 'right'})
    //   button.textContent = 'Depth';
    // });

    //Do not forget to remove the script on unmounting the component!
    // const headerWidgetContainer = document.querySelector('#chart-header-widget');
    // headerWidgetContainer.innerHTML = `<div>Time : <button id="custom-button">Custom Button</button></div>`

    // Add event listeners or interactions to your header widget elements
    // const customButton = document.querySelector('#custom-button');
    // customButton.addEventListener('click', () => {
    //   // Handle button click event
    //   alert('haloooo')
    // });

    return () => script.remove();
  }, []); //eslint-disable-line

  // return <div><div id="chart-header-widget"></div> <div id="tv_chart_container"></div></div>;
  return <div id="tv_chart_container"></div>;
};

export default TradingViewChart;
